import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { colorsPalette, MIDDLE_MARGIN, SMALL_MARGIN } from '../../../../theme';

const TRANSITION_DURATION = '0.3s';

const useStyles = (filterOpened) =>
  makeStyles(() =>
    createStyles({
      wrapper: {
        backgroundColor: 'transparent',
        boxShadow: 'none',
        paddingBottom: SMALL_MARGIN,
        marginBottom: SMALL_MARGIN,
        borderBottom: `1px solid ${colorsPalette.violetAnalyticsCard}`,
        '&:before': {
          display: 'none',
        },
        '&$wrapperDisabled': {
          background: 'transparent',
          pointerEvents: 'auto',
        },
      },
      wrapperExpanded: {
        marginBottom: 0,
      },
      wrapperDisabled: {},
      headingRoot: {
        backgroundColor: 'transparent',
        padding: 0,
        minHeight: 28,
        '&$headingExpanded': {
          minHeight: 28,
          margin: 0,
        },
      },
      headingContent: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        margin: 0,
        '&$headingExpanded': {
          margin: 0,
          marginBottom: MIDDLE_MARGIN,
        },
      },
      headingExpanded: {
        '&$headingDisabled': {
          opacity: 1,
        },
      },
      headingDisabled: {},
      title: {
        fontSize: 22,
        lineHeight: 1.2,
        marginBottom: 0,
        fontWeight: 'bold',
      },
      icon: {
        width: 16,
        height: 16,
        cursor: 'pointer',
        transform: filterOpened ? 'none' : 'rotate(180deg)',
        transition: `transform ${TRANSITION_DURATION} ease-out`,
      },
      contentRoot: {
        padding: 0,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        '& > div:last-child': {
          marginBottom: 0,
        },
      },
    }),
  );

export default useStyles;
